/**
 * @Category React Hook function
 * Provide single source to manage application static menus items
 * 
**/

import { $t } from 'hooks/i18n';

export default function useMenus() {
    
    
    return {
	navbarTopRight: [
  {
    "to": "/mandateworld/add",
    "label": $t('newMandate'),
    "icon": "pi pi-money-bill",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/credittbl/add",
    "label": $t('newCreditReport'),
    "icon": "pi pi-calculator",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/applicationmaster/appstep1",
    "label": $t('newApplication'),
    "icon": "pi pi-bookmark",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/",
    "label": $t('reports'),
    "icon": "pi pi-caret-down",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/loanschedue",
        "label": "Loan Schedule",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/ledgerstatement",
        "label": "Loan Ledger Statement",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  }
],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "to": "/home",
    "label": $t('home'),
    "icon": "pi pi-home",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/applicationmaster/appstep1",
    "label": $t('applyForLoan'),
    "icon": "pi pi-file-export",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/kycupdate",
    "label": $t('kycUpdate'),
    "icon": "pi pi-window-maximize",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/geodashboard",
    "label": $t('geoDashboard'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/nozone",
    "label": $t('settings'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/overduecharges",
        "label": "Overdue Charges Setting",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/settingmaster",
        "label": "SMS Settings",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/smstempetes",
        "label": "SMS Tempetes",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/codesetting",
        "label": "Other Master",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/states",
        "label": "States",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/district",
        "label": "District",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/policestation",
        "label": "Police Station",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/equistates",
        "label": "Equifax State Code",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/areamaster",
        "label": "Area",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/subareamaster",
        "label": "Sub Area",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/assetmaster",
        "label": "Assets",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/hymarkheader",
        "label": "Hymark Header",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/hymarkfooter",
        "label": "Hymark Footer",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/notifymaster",
        "label": "Notification",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanpurpose",
        "label": "Loan Purpose",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/negativemaster",
        "label": "Negative",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('masters'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/membermaster",
        "label": "Members",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/branchmaster",
        "label": "Branch",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/applicationmaster",
        "label": "Loan Application",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/agentmaster",
        "label": "Agent",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/batches",
        "label": "Batch",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/designationmaster",
        "label": "Designation",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/documentmaster",
        "label": "Document",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/empmaster",
        "label": "Employee",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanproduct",
        "label": "Loan Product",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/rankmaster",
        "label": "Rankmaster",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/unitmaster",
        "label": "Unitmaster",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('accounting'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/journalent",
        "label": "Journal Entry",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/journalmaster",
        "label": "Journal List/View",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/accountmaster",
        "label": "Chart of Account",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/accountgroup",
        "label": "Account Group",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/accountpbmaster",
        "label": "Account Primary",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/fixedaccount",
        "label": "Fixed Account",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('accountingReport'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/ledgerstatement",
        "label": "General Ledger",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/generajournal",
        "label": "General Journal",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/trialbalance",
        "label": "Trial Baance",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/balancesheet",
        "label": "Balance Sheet",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/profit",
        "label": "Profit Loss",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/cashflow",
        "label": "Cashflowtatement",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('loan'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/grouploancontract",
        "label": "Disbursement",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanguarantor",
        "label": "Guarantor Info.",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/grouploantransaction",
        "label": "Transactions",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/grouploanamort",
        "label": "Amort",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loangroup",
        "label": "Group",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/meetingcenter",
        "label": "Center",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vemicalculator",
        "label": "Loan Calculator",
        "icon": "pi pi-calculator",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/agenttransaction",
        "label": "Agent Transaction",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/branchtransaction",
        "label": "Branch Transaction",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('loanReports'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/vwclosingbalance",
        "label": "Loan Summary",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanledger",
        "label": "Loan Ledger Statement",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanschedue",
        "label": "Loan Schedule",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vwonetimeoverduepreview",
        "label": "Overdue Charges",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/overduechargeposting",
        "label": "Overdue Charges Posting",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('mandate'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/mandateworld/add",
        "label": "Create Mandate",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/mandateworld",
        "label": "List / View Mandates",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/mandateverify",
        "label": "Mandate Verification",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/debitpresentation",
        "label": "Debit Submission",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/debitverify",
        "label": "Payment Verification",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('hrd'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/leavedetails",
        "label": "Leave Details",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/leavemaster",
        "label": "Leave Master",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/leaveperioddetails",
        "label": "Leave Period Details",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/leavetypemaster",
        "label": "Leave Type",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/attendance",
        "label": "Attendance",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/paydetails",
        "label": "Pay Details",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/paymaster",
        "label": "Pay",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/salarysheet",
        "label": "Salarysheet",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('hrdReports'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/getemployeeleavebalancevw",
        "label": "Leave Balance",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/leaveutilizationsummaryvw",
        "label": "Leave Utilization Summary",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/leavecaendar",
        "label": "Leave Calendar",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/employeeleavehistoryvw",
        "label": "Leave History",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('creditReport'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/credittbl",
        "label": "New Report",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/creditreportsummary",
        "label": "Credit Summary",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('sendMessage'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/sms_alert",
        "label": "Payment Alert",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/sms_notreceive",
        "label": "Payment Not Received",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/sms_received",
        "label": "Payment Confimation",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/nozone",
    "label": $t('analysis'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/demandcollectionreport",
        "label": "Demand vs Collection",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/loanaeing",
        "label": "Loan Ageing",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/emicollectionstatus",
        "label": "EMI Collection Status",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/demandlistvw",
        "label": "Demand List",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      }
    ]
  },
  {
    "to": "/permissions",
    "label": $t('permissions'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/roles",
    "label": $t('roles'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/users",
    "label": $t('users'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/vemicalculator",
    "label": $t('emiCalculator'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/emistatus",
    "label": $t('emiCollectionStatus'),
    "icon": "pi pi-calculator",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/membermaster/add",
    "label": $t('memberEntry'),
    "icon": "pi pi-user-plus",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/loangroup/add",
    "label": $t('groupEntry'),
    "icon": "pi pi-users",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/credittbl/add",
    "label": $t('creditReportCheck'),
    "icon": "pi pi-book",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/creditreportsummary",
    "label": $t('listViewCreditReport'),
    "icon": "pi pi-clone",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/paygroupvw",
    "label": $t('groupCollection'),
    "icon": "pi pi-users",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/grouploantransaction/add",
    "label": $t('collectionEntry'),
    "icon": "pi pi-tablet",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/grouploantransaction",
    "label": $t('todayCollection'),
    "icon": "pi pi-thumbs-up",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/meetingcenter/add",
    "label": $t('meetingCenter'),
    "icon": "pi pi-stopwatch",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/news",
    "label": $t('news'),
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
  }
],
	acLevel: [    
{value: "Detail", label: $t('detail')},
	{value: "Summary", label: $t('summary')}
    ],
	cashBank: [    
{value: "1", label: $t('cashBank')},
	{value: "0", label: $t('no')}
    ],
	acType: [    
{value: "B", label: $t('balanceSheet')},
	{value: "P1B", label: $t('bS^IncomeExpenses')},
	{value: "P1", label: $t('incomeExpense')}
    ],
	gender: [    
{value: "Male", label: $t('male')},
	{value: "Female", label: $t('female')}
    ],
	tenure: [    
{value: "6", label: $t('6')},
	{value: "9", label: $t('9')},
	{value: "12", label: $t('12')},
	{value: "18", label: $t('18')},
	{value: "24", label: $t('24')}
    ],
	gender2: [    
{value: "2", label: $t('male')},
	{value: "1", label: $t('female')}
    ],
	paid: [    
{value: "PAID", label: $t('paid')}
    ],
	alerted: [    
{value: "0", label: $t('no')},
	{value: "1", label: $t('alerted')}
    ],
	odYn: [    
{value: "0", label: $t('no')},
	{value: "1", label: $t('od')}
    ],
	chkFfirstemi: [    
{value: "1", label: $t('yes')},
	{value: "0", label: $t('no')}
    ],
	loanType: [    
{value: "MICRO", label: $t('micro')},
	{value: "PERSONAL", label: $t('personal')},
	{value: "BUSINESS", label: $t('business')},
	{value: "EDUCATION", label: $t('education')},
	{value: "GOLD", label: $t('gold')},
	{value: "HIRE", label: $t('hirePurchase')}
    ],
	amortType: [    
{value: "SIMPLE", label: $t('simple')},
	{value: "REDUCING", label: $t('reducing')}
    ],
	status: [    
{value: "Pending", label: $t('pending')},
	{value: "Approved", label: $t('approved')},
	{value: "Rejected", label: $t('rejected')},
	{value: "Cancelled", label: $t('cancelled')}
    ],
	deductable: [    
{value: "0", label: $t('no')},
	{value: "1", label: $t('yes')}
    ],
	loanType2: [    
{value: "MICRO", label: $t('micro')},
	{value: "PERSONAL", label: $t('personal')},
	{value: "BUSINESS", label: $t('business')},
	{value: "EDUCATION", label: $t('education')},
	{value: "GOLD", label: $t('gold')}
    ],
	paymenttype: [    
{value: "Daily", label: $t('daily')},
	{value: "Weekly", label: $t('weekly')},
	{value: "BiWeekly", label: $t('biweekly')},
	{value: "Monthly", label: $t('monthly')}
    ],
	accounttype: [    
{value: "Saving", label: $t('saving')},
	{value: "Current", label: $t('current')}
    ],
	authtype: [    
{value: "netBanking", label: $t('netbanking')},
	{value: "all", label: $t('all')}
    ],
	frequency: [    
{value: "DAIL", label: $t('daily')},
	{value: "WEEK", label: $t('weekly')},
	{value: "MNTH", label: $t('monthly')},
	{value: "QURT", label: $t('quarterly')},
	{value: "MIAN", label: $t('mian')},
	{value: "YEAR", label: $t('yearly')},
	{value: "ADHO", label: $t('adho')}
    ],
	id1: [    
{value: "AADHAR", label: $t('aadhar')},
	{value: "VOTERID", label: $t('voterid')},
	{value: "RATIONCARD", label: $t('rationcard')},
	{value: "PASSPORT", label: $t('passport')}
    ],
	id2: [    
{value: "PANCARD", label: $t('pancard')},
	{value: "VOTERID", label: $t('voterid')},
	{value: "AADHAR", label: $t('aadhar')},
	{value: "PASSPORT", label: $t('passport')}
    ],
	reskEvaluated: [    
{value: "1", label: $t('lowerDti35LowerRisk')},
	{value: "2", label: $t('highDti45HighRisk')},
	{value: "3", label: $t('lowerLtv80LowerRisk')},
	{value: "4", label: $t('higherLtv90HighRisk')},
	{value: "5", label: $t('salariedEmployeesInStableSectorsAreLowRisk')},
	{value: "6", label: $t('freelancersOrUnstableEmploymentHigherRisk')}
    ],
	frequency2: [    
{value: "Weely", label: $t('weely')},
	{value: "Monthly", label: $t('monthly')},
	{value: "BiWeekly", label: $t('biweekly')},
	{value: "Daily", label: $t('daily')}
    ],
	chargeType: [    
{value: "PERCENT", label: $t('percent')},
	{value: "AMOUNT", label: $t('amount')}
    ],
	accountStatus: [    
{value: "Active", label: $t('active')},
	{value: "Pending", label: $t('pending')}
    ],
	accountStatus2: [    
{value: "Pending", label: $t('pending')},
	{value: "Active", label: $t('active')}
    ],
        exportFormats: {
            print: {
                label: 'Print',
                icon: 'pi pi-print',
                type: 'print',
                ext: '',
            },
            pdf: {
                label: 'Pdf',
                icon: 'pi pi-file-pdf',
                type: 'pdf',
                ext: 'pdf',
            },
            excel: {
                label: 'Excel',
                icon: 'pi pi-file-excel',
                type: 'excel',
                ext: 'xlsx',
            },
            csv: {
                label: 'Csv',
                icon: 'pi pi-table',
                type: 'csv',
                ext: 'csv',
            },
        },
        locales: {
  "fr": "French",
  "ru": "Russian",
  "zh-CN": "Chinese",
  "en-US": "English",
  "it": "Italian",
  "hi": "Hindi",
  "pt": "Portuguese",
  "de": "German",
  "es": "Spanish",
  "ar": "Arabic"
}
    }
}